import { cn } from '@/lib/utils';

interface ProductSaleProgressProps {
  sold: number;
  total: number;
  out: boolean;
  className?: string;
  compact?: boolean;
  showLabel?: boolean;
}

export function ProductSaleProgress({
  sold,
  total,
  out,
  className,
  compact = false,
  showLabel = true,
}: ProductSaleProgressProps) {
  const pct = total > 0 ? Math.min(100, Math.round((sold / total) * 100)) : 0;

  return (
    <div className={className}>
      {showLabel && (
        <div
          className={cn(
            'flex items-center justify-between',
            compact ? 'mb-0.5 text-[10px]' : 'mb-1 text-xs sm:text-sm',
          )}
        >
          <div className="flex items-center gap-1 tabular-nums">
            {compact ? (
              <>
                <span className="font-semibold text-emerald-700">{sold}</span>
                <span className="text-slate-400">/</span>
                <span className="font-medium text-slate-500">{total}</span>
              </>
            ) : (
              <>
                <span className="font-bold text-emerald-700">sold : {sold}</span>
                <span className="text-slate-400">/</span>
                <span className="font-medium text-slate-600">{total}</span>
              </>
            )}
          </div>
        </div>
      )}
      <div
        className={cn('w-full rounded-full bg-slate-200', compact ? 'h-0.5' : 'h-1')}
        aria-label="Sold progress"
      >
        <div
          className={cn('h-full rounded', out ? 'bg-red-500' : 'bg-emerald-500')}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={pct}
          aria-label={`Sold ${sold} of ${total}`}
        />
      </div>
    </div>
  );
}
